import { Button, Message, PageShell } from '@wrenpages/design-system';
import { routes } from '../shared/config/routes';

/** Last-resort boundary (e.g. a route chunk failed to load after a deploy). */
export function RouteError() {
  return (
    <PageShell>
      <Message
        type="not-found"
        title="Something went wrong 🐦"
        lead="Please reload the page. If it keeps happening, email us and we'll fix it."
        actions={
          <Button size="lg" href={routes.home}>
            Back to home
          </Button>
        }
      />
    </PageShell>
  );
}
